export const traceabilityProducts = {
  'prd-esapoct-gestione-poct': {
    key: 'esapoct',
    primaryMedia: '/media/source/images/ESAPoct-1.png',
    secondaryMedia: '/media/source/images/ESApoct-software-e1775749250164.png',
  },
  'prd-samtrace-sistema-esamed-per-la-tracciabilita-delle-provette': {
    key: 'samtrace',
    primaryMedia: '/media/source/images/SAMtrace.png',
    secondaryMedia: '/media/source/images/Login-new.png',
  },
} as const

export type TraceabilityProductId = keyof typeof traceabilityProducts
export type TraceabilityProductKey = (typeof traceabilityProducts)[TraceabilityProductId]['key']

export function isTraceabilityProductId(id: string): id is TraceabilityProductId {
  return id in traceabilityProducts
}
